// @flow
import React from 'react';
import { pure } from 'recompose';
import { Row, Col, EllipsedPagination } from 'angieslist-react-components';
import * as paginationUtils from 'angieslist-app-platform/lib/common/utils/paginationUtils';
import DealCard from './DealCard';
import type { Deal } from '../../types';
import { API_LIMIT } from '../../common/dealsActions';

type Props = {
  deals: Deal[],
  totalCount: number,
  onSelect: (offset: number) => void,
};

type State = {
  pageIndex: number,
};

class DealCardGridComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { pageIndex: 0 };
  }

  state: State;
  props: Props;

  render() {
    const {
      deals, totalCount, onSelect,
    } = this.props;
    const { pageIndex } = this.state;
    const pageCount = paginationUtils.getPageCount(totalCount, API_LIMIT);
    return (
      <div>
        <Row>
          {deals.map(deal => (
            <Col lg={4} sm={6} xs={12} key={deal.id}>
              <div style={{ padding: 6 }}>
                <DealCard
                  deal={deal}
                />
              </div>
            </Col>
          ))}
        </Row>
        <If condition={pageCount > 1}>
          <EllipsedPagination
            pageCount={pageCount}
            pageIndex={pageIndex}
            onChange={(i) => {
              onSelect(paginationUtils.getOffset((i + 1), API_LIMIT));
              this.setState(() => ({ pageIndex: i }));
            }}
          />
        </If>
      </div>
    );
  }
}

export default (pure(DealCardGridComponent): any);



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/DealCardGrid.js